import { getUrlLogin } from './function';

export const isOnline = () => {
    return window.navigator.onLine;
}

export const error500 = () => {
    Vue.prototype.$message({
        message: 'Lỗi hệ thống, Vui lòng thử lại sau',
        type: 'error',
        center: true,
    })
}

export const error422 = () => {
    Vue.prototype.$message({
        message: 'Vui lòng kiểm tra lại dữu liệu truyền lên',
        type: 'warning',
    })
}

export const errorFailed = () => {
    Vue.prototype.$message({
        message: 'Hệ thống đang bảo trì, Vui lòng thử lại sau',
        type: 'warning',
        center: true,
    })
}

export const error403 = (error) => {
    if(window.location.pathname.split('/')[1] != process.env.VUE_APP_BASE_ADMIN.split('/').join('')){
        Vue.prototype.$message({
            message: error.response.data.message,
            type: 'error',
            center: true,
        })
    }else{
        let domain = window.location.hostname != 'localhost' ? window.location.hostname : '';
        document.cookie = 'message=' + error.response.data.message +'; expires=' + new Date(Date.now() + 60000) + '; path=/; domain='+ domain;
        window.location.href = process.env.VUE_APP_BASE_URL_REDIRECT;
    }
}

export const apiGet = async (url, data={}) => {
    if(!isOnline()){
        throw {
            data:{
                message: 'Vui lòng kiểm tra đường truyền của bạn'
            }
        };
    }
    if(typeof(data) !== 'object'){
        throw {
            data:{
                message: 'Tham số thứ 2 chỉ nhận 1 object'
            }
        };
    }
    return axios.get(url, {
        params:data
    }).then(response=>{
        return response.data;
    }).catch(error=>{
        if(!error.response){
            errorFailed();
            getUrlLogin();
        }else if(error.response.status === 401){
            getUrlLogin();
        }else if(error.response.status === 500){
            error500()
        }else if(error.response.status === 403){
            error403(error)
        }else{
            throw error.response;
        }
    })
}

export const apiPost = async (url, data, params = {}) => {
    if(!isOnline()){
        throw {
            data:{
                message: 'Vui lòng kiểm tra đường truyền của bạn'
            }
        };
    }
    if(typeof(params) !== 'object'){
        throw {
            data:{
                message: 'Tham số thứ 3 chỉ nhận 1 object'
            }
        };
    }
    return axios.post(url, data, {
        params: params
    }).then(res => {
        return res.data;
    }).catch(error => {
        if(!error.response){
            errorFailed();
            // getUrlLogin();
        }else if(error.response.status === 401){
            getUrlLogin();
        }else if(error.response.status === 500){
            error500();
            throw error.response;
        }else if(error.response.status === 403){
            error403(error)
        }else{
            throw error.response;
        }
    });
}

export const apiPut = async (url, data, params = {}) => {
    if(!isOnline()){
        throw {
            data:{
                message: 'Vui lòng kiểm tra đường truyền của bạn'
            }
        };
    }
    if(typeof(params) !== 'object'){
        throw {
            data:{
                message: 'Tham số thứ 3 chỉ nhận 1 object'
            }
        };
    }
    return axios.put(url, data, {
        params: params
    }).then(res => {
        return res.data;
    }).catch(error => {
        if(!error.response){
            errorFailed();
            getUrlLogin();
        }else if(error.response.status === 401){
            getUrlLogin();
        }else if(error.response.status === 500){
            error500()
        }else if(error.response.status === 403){
            error403(error)
        }else{
            throw error.response;
        }
    });
}

export const apiDelete = async (url, data = {}) => {
    if(!isOnline()){
        throw {
            data:{
                message: 'Vui lòng kiểm tra đường truyền của bạn'
            }
        };
    }
    if(typeof(data) !== 'object'){
        throw {
            data:{
                message: 'Tham số thứ 2 chỉ nhận 1 object'
            }
        };
    }
    return axios.delete(url, data).then(res => {
        return res;
    }).catch(error => {
        if(!error.response){
            errorFailed();
            // getUrlLogin();
        }else if(error.response.status === 401){
            getUrlLogin();
        }else if(error.response.status === 500){
            error500()
        }else if(error.response.status === 403){
            error403(error)
        }else{
            throw error.response;
        }
    });
}